import { render, staticRenderFns } from "./BindControled.vue?vue&type=template&id=3997fc40&scoped=true"
import script from "./BindControled.vue?vue&type=script&lang=js"
export * from "./BindControled.vue?vue&type=script&lang=js"
import style0 from "./BindControled.vue?vue&type=style&index=0&id=3997fc40&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3997fc40",
  null
  
)

export default component.exports